export const WpnAssign = () => import("./wpn_assign.vue");
export const BulkAssign = () => import("./BulkAssign.vue");
export const WpnDeposit = () => import("./wpn_deposit.vue");
export const WPNList = () => import("./List.vue");
export const WpnCreate = () => import("./Create.vue");
export const WpnEdit = () => import("./Edit.vue");
export const WpnView = () => import("./View.vue");
export const WpnIssue = () => import("./Issue.vue");
export const UserWpns = () => import("./UserWpns.vue");
